import { gql, TypedDocumentNode } from "@apollo/client";
import type { TaskDepartmentNotificationDestination } from "./queries";

export type UpsertTaskDepartmentNotificationDestinationInput = {
  workdayDepartmentName: string;
  emailEnabled: boolean;
  email?: string | null;
};

export type UpsertTaskDepartmentNotificationDestinationMutationResponse = {
  upsertTaskDepartmentNotificationDestination: {
    success: boolean;
    message: string;
    destination: TaskDepartmentNotificationDestination | null;
  };
};

export type UpsertTaskDepartmentNotificationDestinationMutationVariables = {
  input: UpsertTaskDepartmentNotificationDestinationInput;
};

export const UPSERT_TASK_DEPARTMENT_NOTIFICATION_DESTINATION_MUTATION: TypedDocumentNode<
  UpsertTaskDepartmentNotificationDestinationMutationResponse,
  UpsertTaskDepartmentNotificationDestinationMutationVariables
> = gql`
  mutation UpsertTaskDepartmentNotificationDestination(
    $input: BackofficeCRMUpsertTaskDepartmentNotificationDestinationInput!
  ) {
    upsertTaskDepartmentNotificationDestination(input: $input) {
      success
      message
      destination {
        id
        workdayDepartmentName
        email
        emailEnabled
        emailLastError
      }
    }
  }
`;
